import React from "react";
import {
  ButtonContainer,
  Container,
  IconContainer,
  TextContainer,
  MainContainer,
} from "./styled-components";
import Text from "../text";
import { ExpertiseCardComponentProps } from "./types";
import { ReactComponent as AdminIcon } from "../../assets/icons/administration.svg";
import { ReactComponent as NextIcon } from "../../assets/icons/next.svg";

const ExpertiseCard = ({
  title,
  description,
  icon = <AdminIcon />,
  color,
  onClick,
}: ExpertiseCardComponentProps) => {
  return (
    <Container color={color} onClick={onClick}>
      <IconContainer>{icon}</IconContainer>
      <TextContainer>
        <MainContainer>
          <Text size="24px" color="blueDark" lineHeight="32px">
            {title}
          </Text>
          <Text color="grey500">{description}</Text>
        </MainContainer>
        <ButtonContainer>
          <Text size="18px" color="blue" underline weight={700}>
            Sélectionner
          </Text>
          <NextIcon />
        </ButtonContainer>
      </TextContainer>
    </Container>
  );
};

export default ExpertiseCard;
